import React, { memo, useEffect, useState } from 'react';
import userImage from '@/assets/images/login/user.png';
import { Form, Input, Button } from 'antd';
import classnames from 'classnames';
import { useHistory } from 'react-router-dom';
import '../index.less';
import { getLocalStorage, setLocalStorage } from '@/utils/localStorage';
import { isAccount } from '@/utils';
import { lmessage } from '../message';
import StorageFn from '@/utils/electronStorage';
import HeadBtn from '../components/headBtn';

const LOGIN_HISTORY_KEY = 'temp';
const LOGIN_HISTORY_KEYS = 'goBackUserName';

interface LoginHistory {
  username: string | undefined;
  password: string;
  save?: boolean;
}

interface Account {
  username: string | undefined;
}

function LoginForgot() {
  const [form] = Form.useForm();
  const [historyList, setHistoryList] = useState<LoginHistory[]>([]);
  const [dropStatus, setDropStatus] = useState<boolean>(false);
  const [canLogin, setCanLogin] = useState<boolean>(false);
  const [isComposition, setIsComposition] = useState<boolean>(false);
  const history: any = useHistory();

  useEffect(() => {
    setHistoryList([]);
    const hisArr = getLocalStorage(LOGIN_HISTORY_KEY) ? JSON.parse(getLocalStorage(LOGIN_HISTORY_KEY)) : '';
    const userData = getLocalStorage(LOGIN_HISTORY_KEYS) ? getLocalStorage(LOGIN_HISTORY_KEYS) : '';

    if (hisArr && hisArr.length !== 0) {
      setHistoryList(hisArr);
      console.log(hisArr);
      if (userData) {
        getUserName(userData);
        setCanLogin(true);
        return;
      }
      changeLoginHistory(0, hisArr);
      setCanLogin(true);
    }
  }, [form]); // eslint-disable-line react-hooks/exhaustive-deps

  function delStorage(index: number) {
    let temp = [];
    for (let i = 0, len = historyList.length; i < len; i += 1) {
      if (index !== i) {
        temp.push(historyList[i]);
      }
    }
    setHistoryList(temp);
    setLocalStorage(LOGIN_HISTORY_KEY, JSON.stringify(temp));
    StorageFn.electronSetData(LOGIN_HISTORY_KEY, JSON.stringify(temp));
  }
  const changeLoginHistory = (index: number, data: any) => {
    let formData = form.getFieldsValue();
    formData.username = data[index].username;
    form.setFieldsValue({ ...formData });
    setDropStatus(false);
    setCanLogin(true);
  };
  const getUserName = (userData: string) => {
    let formData = form.getFieldsValue();
    formData.username = userData;
    form.setFieldsValue({ ...formData });
    setLocalStorage(LOGIN_HISTORY_KEYS, '');
  };
  const selectLogin = () => {
    setDropStatus(!dropStatus);
  };
  const accountHide = () => {
    setDropStatus(false);
  };
  function changeStatus() {
    const formData = form.getFieldsValue();
    if (formData.username) {
      return setCanLogin(true);
    }
    setCanLogin(false);
  }
  const handleComposition = (e: any) => {
    if (e.type === 'compositionend') {
      setIsComposition(false);
    } else {
      setIsComposition(true);
    }
  };
  function setPass(e: any) {
    if (isComposition === true) return;
    let formData = form.getFieldsValue();
    if (formData.username) {
      formData.username = formData.username.replace(/[\W]/g, '').slice(0, 20);
    }
    form.setFieldsValue(formData);
    changeStatus();
  }
  function formSubmit() {
    form.validateFields().then((res: Account) => {
      if (!res.username) {
        return lmessage.error('请输入重置账号！');
      }
      if (!isAccount(res.username as string)) {
        return lmessage.error('用户名只能是字母开头的字符串,长度6-20位');
      }
      history.push('/login/verify', { username: res.username });
    });
  }
  return (
    <div className="main_position_box" onClick={() => accountHide()}>
      <HeadBtn></HeadBtn>
      <div className="login-switch_mold">
        <div className="currnt_f">账号选择</div>
      </div>
      <div className="login-form_box" id="login_drop">
        <Form form={form} onFinish={formSubmit} autoComplete="off">
          <div className="login_username_box">
            <Form.Item name="username" initialValue="" style={{ marginBottom: '24px' }}>
              <Input
                placeholder="输入账号"
                onCompositionStart={handleComposition}
                onCompositionEnd={handleComposition}
                onKeyUp={event => setPass(event)}
                maxLength={20}
                prefix={<img className="password_icon" src={userImage} alt="" />}
                suffix={
                  <span
                    className={classnames('password_icon history_icon', { down: dropStatus !== true })}
                    onClick={e => {
                      e.stopPropagation();
                      selectLogin();
                    }}
                  ></span>
                }
              ></Input>
            </Form.Item>
            {dropStatus === true && historyList.length !== 0 ? (
              <ul className="accout_item accout__select_item">
                {historyList.map((item: LoginHistory, index: number) => (
                  <li key={index} onClick={() => changeLoginHistory(index, historyList)}>
                    <span>{item.username}</span>
                    <span
                      className="close"
                      onClick={e => {
                        e.stopPropagation();
                        delStorage(index);
                      }}
                    ></span>
                  </li>
                ))}
              </ul>
            ) : null}
          </div>
          <Button
            className={canLogin ? 'login-form_box__submit_button' : 'login-form_box__submit_button disabled'}
            htmlType="submit"
          >
            下一步
          </Button>
        </Form>
      </div>
    </div>
  );
}
export default memo(LoginForgot);
